import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ClinicCard from '../components/ClinicCard'
import TextField from '../components/TextField'
import React, { useEffect, useState } from 'react';
import SendImage from '../images/send.png'
import Papa from 'papaparse';

const tags = [
    "Healthcare",
    "Multi-lingual",
    "Education",
    "Employment",
    "Pregnancy",
    "Parenting",
    "Food",
    "Substance use",
    "Mental health",
    "Counseling",
    "Immigration",
    "Therapy",
    "Youth",
    "Home Care"
];

async function searchResources() {
    const userInput = document.getElementById("resource-search").value;
    const response = await fetch('https://api-handler-19864279100.us-central1.run.app/api/resource-search', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            searchTerm: userInput
        })
    });

    const data = await response.json();
    console.log(data);
}

async function fetchClinics() {
    const response = await fetch('https://api-handler-19864279100.us-central1.run.app/api/get-clinics', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });

    // Read the raw text response
    const rawData = await response.text();

    // Replace invalid NaN values with null in the raw JSON string
    const sanitizedRawData = rawData.replace(/NaN/g, 'null');

    // Parse the sanitized JSON string
    const data = JSON.parse(sanitizedRawData);

    console.log(data);

    return data;
}

export default function Resources() {

    /* Load and parse the clinic data */
    const [clinics, setClinics] = useState([]);
    const [filteredClinics, setFilteredClinics] = useState([]);

    useEffect(() => {
        async function loadClinics() {
            const fetchedClinics = await fetchClinics();
            setClinics(fetchedClinics);
            setFilteredClinics(fetchedClinics)
        }
        loadClinics();
    }, []);

    console.log(clinics);

    /* Runs every time someone changes a filter selection */
    function updateClinics() {
        const selectedTags = [];
        const checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
        var clinicsToShow = [];
        checkboxes.forEach((checkbox) => {
            selectedTags.push(checkbox.value);
        });

        for (var i = 0; i < clinics.length; i++) {
            var showClinic = true;
            const clinicTags = clinics[i]['Tags'].split(", ");
            for (var v = 0; v < selectedTags.length; v++) {
                if (!clinicTags.includes(selectedTags[v])) {
                    showClinic = false;
                }
            }
            if (showClinic) {
                clinicsToShow.push(clinics[i]);
            }
        }   


        // console.log(selectedTags);
        // const newFilteredClinics = clinics.filter((clinic) => {
        //     return selectedTags.every((tag) => {
        //         return clinic['Service'].includes(tag);
        //     });
        // });

        setFilteredClinics(clinicsToShow);
    }

    return (
        <div>
            <Navbar/>
            <h1 style = {{textAlign: 'center', marginTop: '100px', color: 'var(--blue)'}}>Resources</h1>
            <div style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', paddingBottom: '100px'}}>
                <div id = "filter-interface" style = {{width: 'max-content'}}>
                    <p style = {{textAlign: 'left'}}>Filter:</p>
                    <div style = {{justifyContent: 'center', gap: '10px', marginTop: '20px'}}>
                        {tags.map((tag) => (
                            <div style = {{display: 'flex', gap: '6px', marginTop: '5px'}}>
                                <input type = "checkbox" style ={{scale: 1.05}} id = {tag} name = {tag} value = {tag} onChange={updateClinics}/>
                                <p>{tag}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div id = "clinic-grid" style = {{gap: '10px', display: 'grid', marginLeft: 'auto', marginRight: 'auto', width: 'max-content'}}>
                    {filteredClinics.map((clinic, index) => (
                        <ClinicCard 
                            key={index}
                            title={clinic['Name']} 
                            langs={clinic['Languages'] ? clinic['Languages'].split(',') : []}
                            website = {clinic['Website']}
                            city={clinic['City']}
                            state={clinic['State']}
                            services={clinic['Purpose']}
                        />
                    ))}
                </div>
            </div>
            <Footer/>
        </div>
    )
}